
import { defineComponent, inject, ref, computed, reactive } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";

//services
import PayrollService from "@/core/services/PayrollService"
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    setup(props, {emit}) {
        const { t } = useI18n();
        const store = useStore();
        const dialogSearch = inject<any>('dialogSearch')
        const data = ref(<any> {});

        const loader = ref(false)
        const maxlength = ref(8)
        const minlength = ref(3)
        const searchFormRef = ref < FormInstance > ()
        const inputRef = ref<HTMLInputElement | null>(null);
        const pattern = ref<any>(/^[0-9]+$/)
        const searchForm = reactive(<any> {
            doctype: null,
            docnumber: null
        })

        const rules = reactive < FormRules > ({})

        const getDocuments: any = computed < any > (() => {
            return store.getters.currentUser.type_documents;
        })

        const changeDocType = () => {
            searchForm.docnumber = "";
            if (searchForm.doctype == "1") {
                maxlength.value = minlength.value = 8
                //pattern.value = /^[0-9]+$/
            } else {
                maxlength.value = 13
                minlength.value = 3
                pattern.value = /^[a-zA-Z0-9]+$/
            }
            inputRef.value?.focus()
        }

        const onOpen = () => {
            searchForm.doctype = "1";
        }

        const onOpened = () => {
            if(inputRef.value) inputRef.value.focus()
        }

        const onClosed = () => {
            resetForm(searchFormRef.value)
            data.value = {}
            loader.value = false
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) 
                    onSearch();
            });
        };

        const onSearch = async () => {
            loader.value = true
            data.value = {}
            await PayrollService.options('search', searchForm)
            .then( (res) => {
                loader.value = false
                data.value = res.data
                emit("onResponse", res.data)
            }).catch(({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const viewInfo = async () => {
            data.value.status = false
            emit("onResponse", data.value)
        }

        return{
            t,
            dialogSearch,
            data,
            loader,
            rules,
            maxlength,
            minlength,
            searchFormRef,
            inputRef,
            pattern,
            searchForm,
            getDocuments,

            //methods
            onOpen,
            onOpened,
            onClosed,
            resetForm,
            submitForm,
            changeDocType,
            onSearch,
            viewInfo
        }
    },
})
